import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useBookCreate } from '@/module/Author/Book/model/BookQuery';
import { BookSchema, bookSchema, defaultBookValues } from '@/module/Author/Book/model/BookSchema';

import { useAppNotification } from '@feature/utils';

import { BookForm } from './BookForm';

export function BookCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useBookCreate();
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: BookSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newBook => {
        notification.success();
        navigate({ to: '/author/book/$bookId', params: { bookId: String(newBook.id) } });
      },
    });
  };

  return (
    <BookForm
      title={t('books.form.title.create')}
      schema={bookSchema}
      defaultValues={defaultBookValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
      showWosFields={false}
      showScopusFields={false}
    />
  );
}
